import React from "react"
import { FooterView } from "./Footer.view"
import { useFooterQuery } from "./Footer.query"

export function FooterContainer() {
  const data = useFooterQuery()
  return <FooterView data={data} />
}
